import React, { Component } from 'react';
import connect from "react-redux/es/connect/connect";
import {Card} from "material-ui/Card/index";
import ViewTitle from "components/layout/ViewTitle";
import FlatButton from "material-ui/FlatButton/index";
import { CardActions } from 'material-ui/Card';
import TextField from 'material-ui/TextField';
import { NavigationArrowBack } from 'material-ui/svg-icons/';
import Table from 'material-ui/Table/Table';
import TableBody from 'material-ui/Table/TableBody';
import TableRowColumn from 'material-ui/Table/TableRowColumn';
import TableHeader from 'material-ui/Table/TableHeader';
import TableRow from 'material-ui/Table/TableRow';

import * as utils from "./utils";
import {
  shopChecking as shopCheckingAction,
  updateSwitchFunctionWhitelist as updateSwitchFunctionWhitelistAction,
  clearShopCheckingData as clearShopCheckingDataAction,
  clearStateUpdateSwitchFunctionWhitelist as clearStateUpdateSwitchFunctionWhitelistAction,
} from "actions/advancedFunction";


const cardActionStyle = {
  zIndex: 2,
  float: 'right',
};
const stepCheckShopId = 1;
const stepWhitelistShopId = 2;

class FunctionSwitchAddWhitelist extends Component {

  constructor(props) {
    super(props);

    this.initState();

    this.goBack = this.goBack.bind(this);
    this.goBack = this.goBack.bind(this);
    this.onChangeTextInput = this.onChangeTextInput.bind(this);
    this.orderAndFilterShopCheckedResults = this.orderAndFilterShopCheckedResults.bind(this);
    this.save = this.save.bind(this);
    this.getShopCheckStat = this.getShopCheckStat.bind(this);
    this.removeShopFromValidShop = this.removeShopFromValidShop.bind(this);
  }

  initState() {
    this.state = {
      isCanSave: false,
      rawShopId: '',
      errorInputText: '',
      shopIdPrepareCheck: [],
      saveStep: stepCheckShopId,
      removedShopIds: [],
      shopMerchantIdMap: {},
    };
  }

  componentDidMount() {
    this.props.clearShopCheckingData();
  }

  goBack() {
    this.props.history.goBack();
  }

  onChangeTextInput(value) {
    let errorInputText = '';
    let shopIdPrepareCheck = [];
    let shopIds = value.split(',');
    for (let shopId of shopIds) {
      shopId = shopId.trim();
      if (shopId === '') {
        continue;
      }
      if (isNaN(shopId)) {
        errorInputText = `Value ${shopId} not a number`;
        shopIdPrepareCheck = [];
        break;
      } else {
        shopIdPrepareCheck.push(parseInt(shopId, 10));
      }
    }

    let isCanSave = true;
    if (shopIdPrepareCheck.length === 0) {
      isCanSave = false;
    }
    this.setState({
      rawShopId: value,
      isCanSave: isCanSave,
      shopIdPrepareCheck: shopIdPrepareCheck,
      errorInputText: errorInputText
    });
  }

  save(shopCheckedData) {
    const feature = this.props.match.params.feature;
    const isEPayment = feature === utils.E_PAYMENT_FEATURE_ID + '';

    if (this.state.saveStep === stepCheckShopId) {
      let data = {
        shop_ids: this.state.shopIdPrepareCheck,
        not_include_shop_feature_setting: {
          "field": feature,
          "value": utils.SHOP_ID_IN_WHITELIST,
        }
      };
      this.setState({
        saveStep: stepWhitelistShopId,
      });
      this.props.shopChecking(data);
    } else if (this.state.saveStep === stepWhitelistShopId) {
      const shopData = shopCheckedData.filter((shop)=>{
        return !shop.removed && (shop.valid || shop.duplicated)
      }).map((shop)=>{
        const merchantId = this.state.shopMerchantIdMap[shop.shop_id] !== undefined ? this.state.shopMerchantIdMap[shop.shop_id] : shop.merchant_id;
        return {
          shop_id: shop.shop_id,
          merchant_id: merchantId
        }
      });
      let shopIdAddToWhitelist = [];
      for (const shop of shopCheckedData) {
        if (!shop.removed && shop.valid) {
          shopIdAddToWhitelist.push(shop.shop_id);
        }
      }
      let data = { 
        shop_feature_setting_packs: [{
          shops: shopData,
          shop_feature_setting: {
            field: feature,
            value: utils.SHOP_ID_IN_WHITELIST
          },
        }]
      };
      this.props.updateSwitchFunctionWhitelist(data);
    }
  }

  getShopCheckStat(shopCheckedResults) {
    const feature = parseInt(this.props.match.params.feature, 10);
    if (shopCheckedResults) {
      let totalShop = shopCheckedResults.length;
      let numberValid = 0;
      for(const shop of shopCheckedResults) {
        if (!shop.removed && (shop.valid || (feature === utils.E_PAYMENT_FEATURE_ID && shop.duplicated))) {
          numberValid++;
        }
      }
      return {
        totalShop: totalShop,
        numberValid: numberValid,
      };
    }
    return {};
  }

  orderAndFilterShopCheckedResults(shopCheckedResults) {
    if (shopCheckedResults) {
      let newShopCheckedresult = shopCheckedResults.slice();
      newShopCheckedresult.sort((a, b) => a.valid > b.valid);
      for (const shop of newShopCheckedresult) {
        let isRemoved = false;
        for( const removedShopId of this.state.removedShopIds) {
          if (removedShopId === shop.shop_id) {
            isRemoved = true;
            break;
          }
        }
        if (isRemoved) {
          shop.removed = true;
          continue;
        }
        if (shop.valid) {
          shop.owner_mobile_number = shop.shop_info.owner_mobile_number;
          shop.shop_name = shop.shop_info.shop_name;
          shop.merchant_id = shop.shop_info.merchant_id;
          shop.remark = '';
        } else {
          shop.owner_mobile_number = '';
          shop.shop_name = '';
          if (shop.duplicated) {
            shop.remark = 'Duplicated shop';
          } else {
            shop.remark = 'Not exist shop';
          }
        }
      }
      return newShopCheckedresult;
    }
    return null;
  }

  removeShopFromValidShop(shopId) {
    this.setState({
      removedShopIds: [ ...this.state.removedShopIds, shopId]
    });
  }

  render() {
    const feature = parseInt(this.props.match.params.feature, 10);
    const { shopCheckedResults, updateWhitelistSuccess } = this.props;
    if (updateWhitelistSuccess) {
      this.props.clearStateUpdateSwitchFunctionWhitelist();
      this.goBack();
    }

    const featureName = localStorage.getItem(utils.localStoreKeyForCurrentFeatureName);
    const shopCheckedResultsOrdered = this.orderAndFilterShopCheckedResults(shopCheckedResults);
    const shopCheckedStat = this.getShopCheckStat(shopCheckedResultsOrdered);


    let isCanSave = false;
    if (this.state.saveStep === stepCheckShopId) {
      isCanSave = this.state.isCanSave;
    } else if (this.state.saveStep === stepWhitelistShopId) {
      isCanSave = shopCheckedStat.numberValid > 0;
      if(feature === utils.E_PAYMENT_FEATURE_ID) {
        (shopCheckedResultsOrdered || []).forEach((shop) => {
          if(!shop.removed && (shop.valid || shop.duplicated)) {
            const merchantId = this.state.shopMerchantIdMap[shop.shop_id] !== undefined ? this.state.shopMerchantIdMap[shop.shop_id] : shop.merchant_id;
            if(!merchantId) {
              isCanSave = false;
            }
          }
        });
      }
    }

    return (
      <div className="list-page">
        <Card style={ {padding: '5px'} } >
          <CardActions style={cardActionStyle} >
            <FlatButton primary label={'Back'}
                        onClick={this.goBack}
                        icon={ <NavigationArrowBack />}
            />
          </CardActions>
          <ViewTitle title= {`Add New Shops - ${featureName}`}/>
          {
            shopCheckedResultsOrdered ?
              <div>
                <div style={{paddingLeft: '15px'}} >
                  <h4>Total input: {shopCheckedStat.totalShop}</h4>
                  <h4>Valid input: {shopCheckedStat.numberValid}</h4>
                </div>

                <Table>
                  <TableHeader adjustForCheckbox={false} displaySelectAll={false} >
                    <TableRow >
                      <TableRowColumn>Shop ID</TableRowColumn>
                      <TableRowColumn>Owner mobile</TableRowColumn>
                      { feature === utils.E_PAYMENT_FEATURE_ID ? <TableRowColumn>Merchant Id</TableRowColumn> : null }
                      <TableRowColumn>Shop name</TableRowColumn>
                      <TableRowColumn>Remark</TableRowColumn>
                      <TableRowColumn/>
                    </TableRow>
                  </TableHeader>
                  <TableBody displayRowCheckbox={false}>
                    {
                      shopCheckedResultsOrdered.map( shop => (
                        !shop.removed &&
                        <TableRow key={shop.shop_id} selectable={false}>
                          <TableRowColumn>{shop.shop_id}</TableRowColumn>
                          <TableRowColumn>{shop.owner_mobile_number}</TableRowColumn>
                          { feature === utils.E_PAYMENT_FEATURE_ID && (shop.valid || shop.duplicated)?
                          <TableRowColumn>
                            <TextField
                              id={"merchant_id_input" + shop.shop_id}
                              onChange={(event, newValue) => {
                                const inputMerchantId = newValue.trim();
                                this.setState({
                                  shopMerchantIdMap: {
                                    ...this.state.shopMerchantIdMap,
                                    [shop.shop_id]: inputMerchantId,
                                  }
                                });
                              }}
                              hintStyle={{color: '#ccc'}}
                              placeholder="Merchant ID"
                              defaultValue={shop.merchant_id}
                              value={this.state.shopMerchantIdMap[shop.shop_id]}
                              maxLength={utils.MaxMerchantIdLength}
                              rows={1}
                              multiLine={false}
                            />
                          </TableRowColumn> : null }
                          <TableRowColumn>{shop.shop_name}</TableRowColumn>
                          <TableRowColumn>{shop.remark}</TableRowColumn>
                          <TableRowColumn>
                            {
                              shop.valid && !shop.duplicated &&
                              <FlatButton onClick={ () => this.removeShopFromValidShop(shop.shop_id) } primary>Remove</FlatButton>
                            }
                        </TableRowColumn>
                        </TableRow>
                      ))
                    }
                  </TableBody>
                </Table>
              </div>
              :
              <TextField
                onChange={(event, newValue) => this.onChangeTextInput(newValue)}
                value={this.state.rawShopId}
                floatingLabelText="Enter list of shop ID here, separate by comma"
                rows={5}
                multiLine={true}
                errorText={this.state.errorInputText}
                style={{paddingRight: '20px', margin: '15px', width: '90%'}}
              />
          }
          <br />
          <FlatButton
            primary
            label='Save'
            disabled={!isCanSave}
            onClick={ () => this.save(shopCheckedResultsOrdered) }
            style={{
              margin: '5px 12px',
              position: 'relative',
            }}
          />
        </Card>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    shopCheckedResults: state.admin.advancedFunction.shopCheckedResults,
    updateWhitelistSuccess: state.admin.advancedFunction.updateWhitelistSuccess,
  };
}

export default connect(
  mapStateToProps,
  {
    shopChecking: shopCheckingAction,
    updateSwitchFunctionWhitelist: updateSwitchFunctionWhitelistAction,
    clearShopCheckingData: clearShopCheckingDataAction,
    clearStateUpdateSwitchFunctionWhitelist: clearStateUpdateSwitchFunctionWhitelistAction,
  }
)(FunctionSwitchAddWhitelist);



// WEBPACK FOOTER //
// ./src/routes/advancedFunction/FunctionSwitchAddWhitelist.js